function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g829",
    transform: "matrix(0.99964669,0,0,1.0003443,5.2381767e-5,-3.9251753e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4877",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313114px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.0787977,0.11240235 5.1829272,1.0389933 M 0.15026792,0.14902673 H 4.0265153 V 1.0756177 H 5.1306449 V 6.4483158 H 0.15026792 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g81655",
    transform: "matrix(1.1764707,0,0,1.1904172,-120.39412,-106.10132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1200-0",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 103.44957,92.082974 h 0.54778 v 0.821671 h -0.54778 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1202-1",
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 104.34268,92.082974 0.85581,-0.529167 v 1.880008 l -0.85581,-0.529167 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio_on.2cc5953b24a515b5ef0bb758159b1b5a.svg";
export { ForwardRef as ReactComponent };